<template>
  <div class="container-fluid p-0" style="height: 100vh">
    <div class="row">
      <header-vpos></header-vpos>

      <div class="col-12 col-md-12">
        <div class="container-fluid p-2">
          <div class="row">
            <HomeSlideVposVue v-if="!myStore"></HomeSlideVposVue>
            <ul class="mt-3" v-if="riengChecked">
              <li v-for="store in listCuaHang" :key="store.id" class="p-2">
                <div
                  class="w-100 p-3"
                  style="
                    height: 45px;
                    background-color: rgb(239 239 239);
                    border-radius: 10px;
                    border-bottom: 2px rgb(185 185 185) solid;
                    text-align: start;
                    cursor: pointer;
                  "
                >
                  <span style="font-weight: 600; margin-left: 20px"
                    >{{ store.storeName }}
                  </span>
                  | <span> {{ store.storeAdd }}</span>
                </div>
              </li>
            </ul>
            <div class="m-auto" v-if="chungChecked"> </div>
            <CreateStore class="d-none"></CreateStore>
            
          </div>
        </div>
      </div>
      <div class="col-12 col-md-3 p-0 d-none" style="background-color: #f8f8f8">
        <VposLoginVue v-if="!Login"></VposLoginVue>
        <MainMenuVposVue v-if="menuThongTin"></MainMenuVposVue>
        <VposRegister v-if="register"></VposRegister>
      </div>
    </div>
  </div>
</template>
<script>
import { imageUrls } from "@/components/js/urlImg";
import VposLoginVue from "../Accounts/VposLogin.vue";
import MainMenuVposVue from "./MainMenuVpos.vue";
import VposRegister from "../Accounts/VposRegister.vue";
import HomeSlideVposVue from "./SlideVpos/HomeSlideVpos.vue";
import CreateStore from "../DashHome/CreateStore.vue";
import { languages } from "@/components/languages";
import { postLayTiGia } from "@/components/js/VposServiceDanh";
import HeaderVpos from "./HeaderVpos/HeaderVpos.vue";

export default {
  components: {
    MainMenuVposVue,
    VposLoginVue,
    VposRegister,
    HomeSlideVposVue,
    CreateStore,
    HeaderVpos,
  },
  data() {
    return {
      imageUrls: imageUrls,
      currentLanguage: languages.vi,
      Login: false,
      menuThongTin: false,
      register: false,
      user: "",
      listCuaHang: [],
      bannerQuangCao: true,
      myStore: false,
      tyGiaNgoaiTe: [
        {
          iconCo:
            "https://www.vietcombank.com.vn/-/media/Default-Website/Default-images/Icons/Language/VIE.png?db=web",
          maNgoaiTe: "VND",
          ngonNgu: "Tiếng Việt",
          tyGia: "",
        },
        {
          iconCo:
            "https://www.vietcombank.com.vn/-/media/Default-Website/Default-Images/Icons/Flags/im_flag_usa.svg?h=32&w=32&ts=20230610195953&hash=4576D9B7C910424CC72B7A592BA369AE",
          maNgoaiTe: "USD",
          ngonNgu: "English",
          tyGia: "1 USD = 25,485.00 VND",
        },
        {
          iconCo:
            "https://www.vietcombank.com.vn/-/media/Default-Website/Default-Images/Icons/Flags/im_flag_eur.svg?h=32&w=32&ts=20230610195955&hash=10502813C2316A5601FD57F7A0C89A3A",
          maNgoaiTe: "EUR",
          ngonNgu: "English",
          tyGia: "1 USD = 27,860.08 VND",
        },
      ],
    };
  },
 
  mounted() {
    this.handleDataReceived();
    this.layTyGia();
  },

  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      window.location.reload();
    },
    async layTyGia() {
      await postLayTiGia();
    },
  
    handleDataReceived() {
      var data = localStorage.getItem("dataCuaHang");
      this.listCuaHang = JSON.parse(data);
    },
  },
};
</script>
<style>
.dropbtn {
  background-color: #007abb;
  color: white;
  border: none;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  background-color: #007abb !important;
}
</style>